import * as types from './chart.types';
import * as constants from './chart.constants';
import { IChart } from '../../resource/chart/chart.types';

export const initialChartPage = (): types.IInitialChartPage => ({
  type: constants.INITIAL_CHART_PAGE,
});

export const initialChartEditPage = (): types.IInitialChartEditPage => ({
  type: constants.INITIAL_CHART_EDIT_PAGE,
});

export const selectChartVersion = (chartId: IChart['id']): types.ISelectChartVersion => ({
  type: constants.SELECT_CHART_VERSION,
  payload: chartId,
});

export const selectChartDraft = (): types.ISelectChartDraft => ({
  type: constants.SELECT_CHART_DRAFT,
});

export const publishChartVersion = (): types.IPublishChartVersion => ({
  type: constants.PUBLISH_CHART_VERSION,
});

export const publishChartDraft = (): types.IPublishChartDraft => ({
  type: constants.PUBLISH_CHART_DRAFT,
});

export const createEmptyChartDraft = (): types.ICreateEmptyChartDraft => ({
  type: constants.CREATE_EMPTY_CHART_DRAFT,
});

export const createDraftFromVersion = (): types.ICreateDraftFromVersion => ({
  type: constants.CREATE_DRAFT_FROM_VERSION,
});

export const deleteChart = (chartId: IChart['id']): types.IDeleteChart => ({
  type: constants.DELETE_CHART,
  payload: chartId,
});
